import Button from "react-bootstrap/esm/Button";
import BaseButton from "../../../../components/BaseButton";
import TitleBar from "../../../../components/TitleBar";
import styles from './styles.module.css'

import { homeUrl } from "../../../Home/urls";
import { useEffect } from "react";
import BottomBar from "../../../../components/BottomBar";



const Completion = (enable = true) => {
  const type = (new URL(document.location)).searchParams.get('type');

  useEffect(() => {
    if (!enable) return;

    window.history.pushState(null, '', window.location.pathname);
    // const onReload = (event) => {
    //   event.preventDefault();
    //   event.returnValue = '';
    // };
    // window.addEventListener('beforeunload', onReload);
    // return () => {
    //   window.removeEventListener('beforeunload', onReload);
    // };
  }, [enable]);


  let message = null;
  if (type === 'account') {
    message = (
      <>
        <h4>
          新規アカウント申請　送信完了
          <br />
          Application Submission Complete...
        </h4>
        <p>
          新規アカウント申請が送信されました。<br></br>
          承認まで今しばらくお待ちください。申請が承認された場合、メールにてお知らせします。
          <div className="en">
            Application for your new account has been successfully submitted.
            <br />
            When your application is approved, it will be notified by e-mail, so be patient for a while.
          </div>
        </p>
      </>
    );
  } else {
    message = (
      <>
        <h4>
          お問い合わせ　送信完了
          <br />
          Inquiry Submission Complete...
        </h4>
        <p>
          お問い合わせが送信されました。
          <br />
          <div className="en">Your inquiry has been successfully submitted.</div>
        </p>
      </>
    );
  }

  return (
    <>
      <TitleBar />
      <div className={styles.inquiryform}>
        {message}
        <Button href={homeUrl()}>
          トップページに戻る
          <br />
          Return to Top Page
        </Button>
      </div>
      <BottomBar />
    </>
  )
}

export default Completion;
